import { useHistory } from 'react-router-dom';

import { useEffectOnce } from './useEffectOnce';

/**
 * Location interface for React Router v5
 */
interface Location {
  pathname: string;
  search: string;
  hash: string;
}

/**
 * Helper function to create a location string for comparison
 * @param location The location object to convert to string
 * @returns A string representation of the location
 */
const getLocationString = ({ pathname, search, hash }: Location): string => {
  return `${pathname}${search}${hash}`;
};

/**
 * Hook that blocks navigation when certain conditions are met
 * Uses the old react-router-dom API for blocking navigation
 */
export const useLocationBlocker = (): void => {
  const history = useHistory();

  useEffectOnce(() =>
    // block navigation if the action is 'PUSH' and the locations are the same
    history.block((location: Location, action: string) => {
      if (
        action === 'PUSH' &&
        getLocationString(location) === getLocationString(history.location)
      ) {
        return false;
      }
    })
  );
};
